import React from "react"
import { useTranslation } from "react-i18next"

import { TextField } from "components"
import classes from "./CheckoutNote.module.scss"

const CheckoutNote = props => {
  const { note, setNote } = props

  const [t] = useTranslation()

  const handleChange = (e) => {
    setNote(e.target.value)
  }

  return (
    <div className={classes["input"]}>
      <label className={classes["label"]}>
        {t("توضیحات_سفارش")}
      </label>

      <TextField
        rows={3}
        placeholder={t("توضیحات_سفارش_را_وارد_کنید")}
        componentClass="textarea"
        type="text"
        maxLength={300}
        value={note}
        onChange={handleChange}
      />
    </div>
  )
}

export default CheckoutNote